import { render } from "./converter_body_main.vue?vue&type=template&id=b8c0a45e"
import script from "./converter_body_main.vue?vue&type=script&lang=js"
export * from "./converter_body_main.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__